import { openNewTab } from '@pocapan/shared/utils/UIUtils';
import type { GetLatestPhotoCardsResponse } from '@pocapan/shared/domains/photoCards/services/photoCardService';

type Props = {
  photoCard: GetLatestPhotoCardsResponse['photoCards'][number];
};

const LatestPhotoCardItem = ({ photoCard }: Props) => (
  <button
    key={photoCard.photoCardId}
    type="button"
    className="relative w-full aspect-[59/95]"
    onClick={() => openNewTab(`/photo_cards/${photoCard.photoCardId}`)}
  >
    <img
      src={photoCard.mediumThumbnailUrl ?? ''}
      alt={photoCard.artistName ?? ''}
      className="rounded-[7px] w-full h-full object-cover"
    />
    <div
      className="absolute inset-0 rounded-[7px]"
      style={{
        background:
          'linear-gradient(0deg, rgba(0, 0, 0, 0.75) 0%, rgba(0, 0, 0, 0.08) 50.31%, rgba(0, 0, 0, 0.05) 100%)'
      }}
    />
    <p className="absolute bottom-[7px] left-[4px] right-[4px] text-[10px] font-medium text-white line-clamp-2 text-left break-keep">
      {photoCard.memberName && `${photoCard.memberName}`} {photoCard.categoryName}
    </p>
  </button>
);

export default LatestPhotoCardItem;
